<template>
  <div class="panel-in-tab">
    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <div style="height: 10px"></div>
      </template>
      <el-table
        :data="tableData.list"
        ref="tableRef"
        border
        stripe
        highlight-current-row
        :height="maxTableHeight"
        :header-cell-style="{ textAlign: 'center' }"
        :cell-style="{ textAlign: 'center' }"
        v-loading="loading"
      >
        <el-table-column label="上限" prop="limitUpper"></el-table-column>
        <el-table-column label="下限" prop="limitLower"></el-table-column>
        <el-table-column label="系数" prop="commissionCoefficient"></el-table-column>
        <el-table-column label="更新人" prop="updatedBy"></el-table-column>
        <el-table-column label="更新时间" prop="updatedDate"></el-table-column>
        <el-table-column label="操作" width="180px" align="center">
          <template slot-scope="scope">
            <el-link type="primary" :underline="false" @click="edit(scope.row)">修改</el-link>
            <el-link type="primary" :underline="false" @click="adjustingRecords(scope.row)">查看调整记录</el-link>
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div style="text-align: right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[30, 60, 90]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          >
          </el-pagination>
        </div>
      </template>
    </table-panel>

    <edit-dialog ref="content" :visible.sync="dialogVisible" :tableDataList="editData" @success="onSearch" v-if="dialogVisible"/>
    <adjustment-record-dialog :visible.sync="isShowAdjustmentRecord" :rowData="rowData" @success="onSearch" v-if="isShowAdjustmentRecord"/>
  </div>
</template>

<script>
import axios from "@/utils/axiosInstance";
import editDialog from "./components/edit";
import adjustmentRecordDialog from "./components/adjustmentRecord"
import tableMixin from "@/utils/tableMixin";
export default {
  mixins: [tableMixin],
  components: { editDialog, adjustmentRecordDialog },
  data() {
    return {
      form: {
        storeName: '全部',
      },
      tableHeight: 0,
      tableData: {
        list: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      dialogVisible: false,
      isShowAdjustmentRecord: false,
      dialogConfig: {},
      rowData: {},
      storeList: [],
      editData: [],
      queryCriteria: [],
      searchFormData: [],
      loading: false,
      currencyForm: {
        pageSize: 999999,
        pageNum: 1,
        reportCode: "",
        param: {},
        queryMatch: [
          // {
          //   attributeName: '',
          //   val: {},
          //   op: ''
          // }
        ],
        orderList: [
          // {
          //   attributeName: '',
          //   type: ''
          // }
        ],
        orderType: "",
        hasCount: "N",
        groupAttr: "",
      },
    };
  },
  computed: {},
  mounted() {
    this.onSearch();
  },
  methods: {
    onSearch() {
      this.tableData.pageNum = 1;
      this.queryCriteria = [];
      this.init();
    },
    async init(type) {
      this.loading = true;
      let filter = this.queryCriteria.filter((item) => item.val.length && item.val[0]);
      let data = { ...this.currencyForm };
      data.pageSize = this.tableData.pageSize;
      data.pageNum = this.tableData.pageNum;
      data.reportCode = "newProductShootingCommissionConfig";
      data.queryMatch = filter || [];
      data.hasCount = "Y";
      this.searchFormData = data;
      axios
        .post(`/ec-pc-api/custom/reports/data/newProductShootingCommissionConfig`, data)
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
            this.editData = JSON.parse(JSON.stringify(this.tableData.list))
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init(this.searchFormData);
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init(this.searchFormData);
    },
    // 重置
    reset() {
      this.tableData.pageNum = 1;
      this.tableData.pageSize = 30;
      this.form = {};
      this.onSearch();
    },
    // 修改 弹出dialog
    edit(row) {
      this.rowData = row;
      this.dialogVisible = true;
    },
    async delRow(row) {
      let text = row.status == '启用' ? '停用' : '启用'
      let status = await this.$confirm(`是否确认${text}该条数据？`, "提示", { type: "warning" });
      if (status !== "confirm") return;
      let res = await this.$q.newProduct.shootingAccountingConfigUpdateStatus({ fragment: [row.dataId] });
      if (res.success) {
        this.$message.success(text +"成功");
      } else {
        this.$message.fail(text +"失败");
      }
      this.init();
    },
    adjustingRecords(row) {
      this.isShowAdjustmentRecord = true
      this.rowData = row
    },
  },
};
</script>

<style lang="stylus" scoped>
.panel-in-tab
  >>> .search-outer>div
    padding 0
</style>
<style lang="css">
.el-tooltip__popper {
  max-width: 40%;
}
</style>
